import * as React from "react";
import { Button, Modal, Textarea, Toast } from "react-ui";

import { ICandyApiDraftClient } from "../../../../../../Common/CandyApiClient/ICandyApiClient";
import { DraftPresentationType } from "../../../../../../Common/CandyApiClient/Types/Presentations/DraftPresentationType";

interface SetInnerModalProps {
    candyApiDraftClient: ICandyApiDraftClient;
    onClose: () => void;
}

export function SetInnerModal(props: SetInnerModalProps): JSX.Element {
    const [innerValue, setInnerValue] = React.useState("");

    const handleSetInnerClick = async () => {
        try {
            await props.candyApiDraftClient.setPresentation(DraftPresentationType.inner, innerValue);
            window.location.reload();
        } catch {
            Toast.push("Не удалось уставноить inner");
        }
    };

    return (
        <Modal onClose={props.onClose} ignoreBackgroundClick>
            <Modal.Header>Set inner</Modal.Header>
            <Modal.Body>
                <Textarea
                    width={500}
                    rows={20}
                    value={innerValue}
                    onValueChange={setInnerValue}
                    placeholder="Сюда надо вставить json от .../presentation/inner"
                />
            </Modal.Body>
            <Modal.Footer panel>
                <Button use="primary" onClick={handleSetInnerClick}>
                    Set inner
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
